import Vue from 'vue';

export const GET_USER = 'GET_USER'; // 获取用户信息
export const USER_SIGNIN = 'USER_SIGNIN'; // 登录成功
export const USER_SIGNOUT = 'USER_SIGNOUT'; // 退出登录

export default {
    state: {
        user: JSON.parse(localStorage.getItem('g7user')) || {},
    },
    getters: {
        [GET_USER] (state) {
            if (typeof state.user === 'string'){
                state.user = JSON.parse(state.user);
            }
            return state.user;
        }
    },
    mutations: {
        [USER_SIGNIN] (state, user) {
            localStorage.setItem('g7user', JSON.stringify(user))
            Object.assign(state.user, user);
        },
        [USER_SIGNOUT] (state) {
            localStorage.removeItem('g7user')
            localStorage.removeItem('g7s_token');
            localStorage.removeItem('cooperative');
            localStorage.removeItem('camera');
            localStorage.removeItem('pwd_switch');
            if (localStorage.hasOwnProperty('usedTip')){
                localStorage.removeItem('usedTip')
            }
            if (Object.keys(state).user) {
                Object.keys(state).forEach(k => Vue.delete(state, k));
            }
        }
    },
    actions: {
        [USER_SIGNIN] ({commit}, user) {
            commit(USER_SIGNIN, user);
        },
        [USER_SIGNOUT] ({commit}) {
            commit(USER_SIGNOUT);
        }
    }
};
